import { render, staticRenderFns } from "./AddReviewModal.vue?vue&type=template&id=ce3639e0&scoped=true"
import script from "./AddReviewModal.vue?vue&type=script&lang=js"
export * from "./AddReviewModal.vue?vue&type=script&lang=js"
import style0 from "./AddReviewModal.vue?vue&type=style&index=0&id=ce3639e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3639e0",
  null
  
)

export default component.exports